import NoChallengesPanel from './NoChallengesPanel';

export default NoChallengesPanel;
